module.exports = __webpack_public_path__ + "static/img/6547_phase_function_Paper_PointsHejduk_Prediction.c4b757a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6547_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kQEV
// module chunks = 0